<template>
	<Accordion
		:title="labels.title"
		:icon="icon"
		:icon-hint="transUcfirst('tag_group.visible_in_player')"
		:open="open"
		:disabled="disabled"
		:disabled-hint="disabledHint"
		@toggle="$emit('toggle', $event)"
	>
		<MatchTags
			:tag-options="matchTagsOptions"
			@tag-click="$emit('click', $event)"
		/>
	</Accordion>
</template>

<script>
import Accordion from '@components/accordion/Accordion';
import MatchTags from '@videotools/js/one/components/TagCenter/MatchTags';
import { mapGetters } from 'vuex';
import SectionLabelsMixin from '@videotools/js/one/components/TagGroups/mixin/SectionLabelsMixin';
import { SECTION_COMPETITION } from '@videotools/js/api/entities/TagGroup';

export default {
	name:       'MatchTagsSection',
	components: { MatchTags, Accordion },
	mixins:     [SectionLabelsMixin],
	props:      {
		open: {
			type:    Boolean,
			default: true,
		},
		icon: {
			type:     String,
			required: false,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		disabledHint: {
			type:    String,
			default: null,
		},
	},
	computed: {
		...mapGetters({
			_matchTags:          'tags/matchTags',
			isPlayerCompetition: 'event/isPlayerCompetition',
		}),
		labels() {
			return {
				title: this.translateSectionLabel(SECTION_COMPETITION, this.isPlayerCompetition),
			};
		},
		matchTagsOptions() {
			return this._matchTags.map(tag => ({
				key:       tag.id,
				label:     tag.name,
				value:     tag.id,
				highlight: tag.highlight,
				targets:   tag.targets,
				tag:       tag,
			}));
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
